import { render, staticRenderFns } from "./consultation_info.vue?vue&type=template&id=187fbffe&scoped=true"
import script from "./consultation_info.vue?vue&type=script&lang=js"
export * from "./consultation_info.vue?vue&type=script&lang=js"
import style0 from "./consultation_info.vue?vue&type=style&index=0&id=187fbffe&prod&scoped=true&lang=css"
import style1 from "./consultation_info.vue?vue&type=style&index=1&id=187fbffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187fbffe",
  null
  
)

export default component.exports